//#region Libraries
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
//#endregion
//#region Components
import Preloader from "components/Preloader/Preloader";
import AcadReinforceAttendanceComponent from "./AcadReinforceAttendanceComponent";
//#endregion
//#region Services
import { requestAcadReinforceExists } from "services/acadReinforce/aboutAcadReinforce";
import { acadReinforcementSessionStorage } from "services/storage/acadReinforcement";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

const AcadReinforceAttendance = () => {
	const [acadReinforceExists, setAcadReinforce] = useState(null);
	useEffect(() => {
		verifyIfAcadReinforceExists();
	}, []);
	const verifyIfAcadReinforceExists = async () => {
		const acadReinforceData =
			acadReinforcementSessionStorage.acadReinforceDataToAttendance.get();
		if (!acadReinforceData?.id) {
			setAcadReinforce(false);
			return;
		}
		const acadReinforceExists = await requestAcadReinforceExists(
			acadReinforceData.id
		);
		setAcadReinforce(acadReinforceExists);
	};
	if (acadReinforceExists === null) return <Preloader hidden={false} />;
	if (!acadReinforceExists)
		return (
			<Navigate
				to={ABSOLUTE_PATHS.ACAD_REINFORCE_LIST}
				replace
			/>
		);
	return <AcadReinforceAttendanceComponent />;
};

export default AcadReinforceAttendance;
